function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { buttonClasses } from "@mui/material/Button";
export const Button = {
    MuiButton: {
        defaultProps: {
            variant: "contained",
            disableElevation: true
        },
        styleOverrides: {
            root: ({ theme })=>({
                    borderRadius: 8,
                    [`&.${buttonClasses.sizeLarge}`]: _object_spread({
                        padding: theme.spacing(2, 5)
                    }, theme.typography.buttonLarge),
                    [`&.${buttonClasses.sizeMedium}`]: _object_spread({
                        padding: theme.spacing(1.5, 4)
                    }, theme.typography.buttonMedium),
                    [`&.${buttonClasses.sizeSmall}`]: _object_spread({
                        padding: theme.spacing(1, 2)
                    }, theme.typography.buttonSmall)
                })
        }
    }
};

//# sourceMappingURL=Button.js.map